import zy from "../assets/img2/zy2.png";
import bzq from "../assets/img2/bzq2.png";
import cc from "../assets/img2/cc2.png";
import wb from "../assets/img2/wb2.png";
import lj from "../assets/img2/lj2.png";

const dataList = [
  {
    id: "001",
    img: zy,
    title: "二十大报告里看未来｜为什么要走中国式现代化道路？",
    link: "http://www.xinhuanet.com/sikepro/20221212/3474bb2878534793bc093ec091fa8ed5/c.html",
    src: "https://vodpub1.v.news.cn/original/20221207/8f7d15337ba246e088dc32ecc54e8f7c.mp4",
    shade: 1,
  },
  {
    id: "002",
    img: bzq,
    title: "二十大报告里看未来｜什么是中国式现代化？",
    link: "http://www.news.cn/sikepro/20221213/1d03abd4aa644bd99b11a4a8a727d925/c.html",
    src: "https://vodpub1.v.news.cn/original/20221207/c66d4a61ad204803be1f44afc6b8f17f.mp4",
    shade: 1,
  },
  {
    id: "003",
    img: cc,
    title: "二十大报告里看未来｜如何走好中国式现代化道路？",
    link: "http://www.news.cn/sikepro/20221214/90623e3cd88941e2a0183a63a9974e49/c.html",
    src: "https://vodpub1.v.news.cn/original/20221207/a62ffa1bf9274b1aa0f87f0fcf2ab596.mp4",
    shade: 1,
  },
  {
    id: "004",
    img: wb,
    title:
      "二十大报告里看未来｜为什么说高质量发展是全面建设社会主义现代化国家的首要任务？",
    link: "http://www.news.cn/sikepro/20221215/2f49824a307a449c85e3bf3ba17cf058/c.html",
    src: "https://vodpub1.v.news.cn/original/20221207/e975ffde617d418e84a2746ce01c00c4.mp4",
    shade: 1,
  },
  {
    id: "005",
    img: lj,
    title: "二十大报告里看未来｜中国式现代化会为世界发展带来什么？",
    link: "http://www.news.cn/sikepro/20221216/465b48dd041044f599705051013cbb6b/c.html",
    src: "https://vodpub1.v.news.cn/original/20221207/76ef496e9b4d403c9b1d3f0cd01cc764.mp4",
    shade: 1,
  },
];

export default dataList;
